module.exports = __webpack_public_path__ + "img/tip1.8c9a687a.png";